import $axios from '~/plugins/axios';

import { Api, GetWarehouseParams, PaginatorResult, Warehouse } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'campaignsPage',
			pageSizeQueryKey: 'campaignsPerPage',
			itemCountGetter: 'campaigns/list/totalCount',
		}),
	})
	.withState({
		storedWarehouses: {} as Dict<Warehouse>,
		warehouses: [] as Warehouse[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (warehouseId: number) => (
			state.storedWarehouses[warehouseId] ?? null
		),
		page: state => state.warehouses,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_WAREHOUSES (state, warehouses: Warehouse[]) {
			state.storedWarehouses = {
				...state.storedWarehouses,
				...createDict(warehouses, (warehouse) => warehouse.id),
			};
		},
		SET_WAREHOUSES (state, warehouseIds: number[]) {
			state.warehouses = warehouseIds.map(id => state.storedWarehouses[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetWarehouseParams) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/warehouse', { params });
			commit('SET_LOADING', false);

			const warehouses = data.payload;
			const warehouseIds = warehouses.map(warehouse => warehouse.id);

			commit('SET_STORED_WAREHOUSES', warehouses);
			commit('SET_WAREHOUSES', warehouseIds);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
